/**
 * BerryPeek
 * Web client for BerryPeek v4
 * @author  biohzrdmx <github.com/biohzrdmx>
 * @copyright Copyright (c) 2022 BerryPeek. All rights reserved
 */

import { Uploader } from './Uploader.js'

class BerryPeek {

  /**
   * Options object
   * @type {Object}
   */
  _options = {};

  /**
   * Uploader instance
   * @type {Uploader}
   */
  _uploader;

  /**
   * Constructor
   * @param  {Object} options Options object
   * @return {null}
   */
  constructor(options = {}) {
    this._options = options;
    this._uploader = new Uploader();
    //
    jQuery(document).ready( ($) => {
      this.onDomReady();
    });
  }

  /**
   * On DOM ready callback
   * @return {null}
   */
  onDomReady() {

    $('.img-initial').initial({
        width: 512,
        height: 512,
        fontSize: 320
    });

    $('a[href^="#"]').on('click', function(e) {
      const el = $(this),
        href = el.attr('href'),
        target = href != '#' ? $(href) : [];
      if ( target.length && !target.hasClass('tab') && !target.hasClass('mfp-popup') ) {
        e.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top - ( $('header').outerHeight() + 16 )
        }, 350);
      }
    });

    $('.tab-list li a').on('click', function(e) {
      const el = $(this),
        href = el.attr('href'),
        target = $(href),
        li = el.closest('li');
      e.preventDefault();
      li.addClass('is-selected').siblings('li').removeClass('is-selected');
      target.addClass('is-active').siblings('.tab').removeClass('is-active');
    }).first().trigger('click');

    $('.js-top').on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: 0
      }, 350);
    });

    $('.js-toggle-password').on('click', function(e) {
      const el = $(this),
        group = el.closest('.form-group'),
        input = group.find('input'),
        icon = group.find('i');
      e.preventDefault();
      el.toggleClass('active');
      input.attr('type', el.hasClass('active') ? 'text' : 'password');
      if ( el.hasClass('active') ) {
        icon.removeClass('fa-lock').addClass('fa-lock-open');
      } else {
        icon.removeClass('fa-lock-open').addClass('fa-lock');
      }
    });

    $('.js-toggle-answer').on('click', function(e) {
      const el = $(this),
        faq = el.closest('.faq');
      e.preventDefault();
      faq.toggleClass('is-open');
    });

    $('.js-show-modal').on('click', function(e) {
      const el = $(this),
        href = el.attr('href');
      e.preventDefault();
      //
    });

    $('.js-change-question').on('change', function(e) {
      const el = $(this),
        selected = el.find('option:selected'),
        target = el.data('target') || '',
        label = $(target);
      label.text( selected.data('question') );
    });

    $('.js-qr').each(function() {
      var el  = $(this),
        code = el.data('code');
      var qr = qrcode(5, 'L');
      qr.addData(code);
      qr.make();
      el.append( qr.createImgTag(5) );
    });

    $('.js-share').on('click', function(e) {
      let el = $(this);
      e.preventDefault();
      if (navigator.share) {
        navigator.share({
          title: el.data('title'),
          url: el.data('url')
        }).catch(function() {
          // Do nothing
        });
      } else {
        // Fallback
      }
    });

    $('.js-show-modal').magnificPopup({
      type:'inline',
      midClick: true
    });

    $('.form-group.has-error').on('focus', 'input, select', function(e) {
      const el = $(this),
        group = el.closest('.form-group');
      group.removeClass('has-error');
      group.off('focus');
    });

    $('.swiper').each(function(index, el) {
      const wrapped = $(el),
        slides = wrapped.data('slides') || 1;
      const swiper = new Swiper(el, {
        breakpoints: {
          768: {
            slidesPerView: slides,
          }
        },
        loop: true,
        spaceBetween: 16,
        autoplay: {
          delay: 15000,
          disableOnInteraction: true
        },
        pagination: {
          el: '.swiper-pagination',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      });
    });

    const body = $('body'),
          mainHeader = $('.main-header'),
          fixedHeader = mainHeader.clone();
    fixedHeader.addClass('is-fixed');
    mainHeader.after(fixedHeader);

    const scrollSpy = () => {
      const pos = $('html, body').scrollTop();
      if ( pos >= 300 && !body.hasClass('has-fixed-header') ) {
        body.addClass('has-fixed-header');
      } else if ( pos < 300 && body.hasClass('has-fixed-header') ) {
        body.removeClass('has-fixed-header');
      }
      window.requestAnimationFrame(scrollSpy);
    };
    scrollSpy();

    this._uploader.init();
  }
}

export { BerryPeek };